import { FC } from 'react';

const PromptCardTags: FC<{ tags: string[]; }> = ({ tags }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {tags && tags.length > 0 && (
        tags.map((tag, index) => (
          <span key={index} className="inline-block bg-brand-light-gray rounded-full px-3 py-1 text-xs text-brand-dark-blue font-medium">
            {tag}
          </span>
        ))
      )}
    </div>
  );
};

export default PromptCardTags;
